module.exports = __webpack_public_path__ + "img/JakeAnderson.05732a72.jpg";